var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[(!_vm.loggedIn)?_c('login'):_vm._e(),_c('snippet',{attrs:{"name":_vm.homeMessageKey}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }